import React, { useState } from 'react';
import { Countdown } from './Countdown';
import { motion } from 'framer-motion';
import { CHECKOUT_URLS } from '../lib/checkout';
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<'esencial' | 'profesional'>('profesional');
  return <section id="pricing" className="bg-navy text-white py-16 px-4 border-t border-white/10" data-id="element-134">
      <div className="max-w-[720px] mx-auto" data-id="element-135">
        <div className="text-center mb-12" data-id="element-136">
          <h3 className="text-lg font-bold text-white/80 mb-6 tracking-widest uppercase" data-id="element-137">
            ESTA OFERTA TERMINA EN
          </h3>
          <Countdown format="boxes" data-id="element-138" />
        </div>

        <div className="text-center mb-10" data-id="element-139">
          <h2 className="text-2xl md:text-4xl font-extrabold mb-3 leading-tight" data-id="element-140">
            ELEGÍ TU EL COSTO DE NO HACER NADA
          </h2>
          <p className="text-[15px] font-bold text-emerald" data-id="element-141">
            Ambas opciones incluyen los 6 bonos completos
          </p>
        </div>

        <div className="flex flex-col gap-4 mb-8" data-id="element-142">
          {/* Plan Esencial */}
          <label className={`relative block cursor-pointer rounded-2xl p-5 border-2 transition-all ${selectedPlan === 'esencial' ? 'border-white bg-white/5' : 'border-white/10 bg-transparent hover:bg-white/5'}`} data-id="element-143">
            <div className="flex items-start gap-4" data-id="element-144">
              <div className="mt-1 flex-shrink-0" data-id="element-145">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'esencial' ? 'border-emerald' : 'border-white/30'}`} data-id="element-146">
                  {selectedPlan === 'esencial' && <div className="w-3 h-3 rounded-full bg-emerald" data-id="element-147" />}
                </div>
                <input type="radio" name="plan" value="esencial" checked={selectedPlan === 'esencial'} onChange={() => setSelectedPlan('esencial')} className="sr-only" data-id="element-148" />
              </div>
              <div className="flex-1" data-id="element-149">
                <h3 className="text-lg font-bold mb-1" data-id="element-150">📘 GUÍA ESENCIAL</h3>
                <p className="text-[14px] text-white/70 mb-3" data-id="element-151">
                  6 tomos + 6 bonos estratégicos
                </p>
                <div className="flex items-center gap-2" data-id="element-152">
                  <span className="line-through text-white/50 text-sm" data-id="element-153">
                    $29.990
                  </span>
                  <span className="text-xl font-bold" data-id="element-154">$19.990</span>
                </div>
              </div>
            </div>
          </label>

          {/* Plan Profesional */}
          <label className={`relative block cursor-pointer rounded-2xl p-5 border-2 transition-all ${selectedPlan === 'profesional' ? 'border-emerald bg-emerald/5 shadow-[0_0_20px_rgba(29,158,117,0.15)]' : 'border-white/10 bg-transparent hover:bg-white/5'}`} data-id="element-155">
            <div className="absolute -top-3 right-4 flex gap-2" data-id="element-156">
              <span className="bg-gold text-navy text-[10px] font-bold px-2 py-1 rounded uppercase shadow-sm" data-id="element-157">
                ⭐ MÁS ELEGIDO
              </span>
            </div>

            <div className="flex items-start gap-4" data-id="element-158">
              <div className="mt-1 flex-shrink-0" data-id="element-159">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'profesional' ? 'border-emerald' : 'border-white/30'}`} data-id="element-160">
                  {selectedPlan === 'profesional' && <div className="w-3 h-3 rounded-full bg-emerald" data-id="element-161" />}
                </div>
                <input type="radio" name="plan" value="profesional" checked={selectedPlan === 'profesional'} onChange={() => setSelectedPlan('profesional')} className="sr-only" data-id="element-162" />
              </div>
              <div className="flex-1" data-id="element-163">
                <h3 className="text-lg font-bold mb-1" data-id="element-164">🚀 PLAN PROFESIONAL</h3>
                <p className="text-[14px] text-white/70 mb-3" data-id="element-165">
                  8 tomos + 6 bonos + Plan a 5 años
                </p>
                <div className="flex items-center gap-2 mb-2" data-id="element-166">
                  <span className="line-through text-white/50 text-sm" data-id="element-167">
                    $39.990
                  </span>
                  <span className="text-xl font-bold" data-id="element-168">$29.990</span>
                </div>
                <span className="inline-block bg-emerald text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase" data-id="element-169">
                  AHORRÁS $10.000
                </span>
              </div>
            </div>
          </label>
        </div>

        <div className="flex flex-col items-center" data-id="element-170">
          <motion.a href={CHECKOUT_URLS[selectedPlan]} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full h-[56px] bg-emerald text-white font-bold text-[18px] rounded-xl flex items-center justify-center shadow-[0_4px_14px_0_rgba(29,158,117,0.39)] hover:bg-emerald-600 transition-colors mb-3" data-id="element-171">
            {selectedPlan === 'profesional' ? 'SÍ, QUIERO EL PLAN PROFESIONAL →' : 'SÍ, QUIERO LA GUÍA ESENCIAL →'}
          </motion.a>

          <p className="text-[13px] text-white/50 mb-6 text-center" data-id="element-172">
            {selectedPlan === 'profesional' ? 'La opción más elegida por quienes quieren el sistema completo' : 'Ideal para empezar a ordenar tus finanzas desde cero'}
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[13px] text-white/60 font-medium" data-id="element-173">
            <span className="flex items-center gap-1" data-id="element-174">🔒 Pago seguro</span>
            <span data-id="element-175">·</span>
            <span className="flex items-center gap-1" data-id="element-176">⚡ Acceso inmediato</span>
            <span data-id="element-177">·</span>
            <span className="flex items-center gap-1" data-id="element-178">🛡️ Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}